import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '@teammood/shared/ui/dialog';
import { Digest } from '../digest.type';
import { DigestDialogComponent } from './digest-dialog.component';

@Injectable(
  { providedIn: 'root' }
)
export class DigestDialogService {
    constructor(
      private _dialogService: DialogService,
    ){}
  async openDigestDialog(digest: Digest): Promise<MatDialogRef<DigestDialogComponent>> {
    return this._dialogService.open(DigestDialogComponent, {
      width: '100%',
      maxWidth: '800px',
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      data: {
        digest: digest,
      }
    })
  }
}